// extracted by css-extract-rspack-plugin
export default {"cls1":"Banner-cls1_K68","cls2":"Banner-cls2_CYK Banner-cls1_K68"};